import React, { useEffect, useState } from 'react'
import API from '../services/API'
import {
  Box,
  Typography,
  Button,
  useTheme,
  Stack,
  IconButton,
} from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import { motion, AnimatePresence } from 'framer-motion'
import moment from 'moment'
import { Close } from '@mui/icons-material'

const GlobalBanners = () => {
  const [globalSettings, setGlobalSettings] = useState(null)
  const [hideBanner, setHideBanner] = useState(false)
  const theme = useTheme()

  const hasPlannedMaintenance =
    !!globalSettings?.maintenance?.start && !!globalSettings?.maintenance?.end

  const hasEmergencyMaintenance =
    !!globalSettings?.maintenance?.emergencyMaintenance

  const isUpcoming =
    hasPlannedMaintenance && moment(globalSettings.maintenance.start)

  const showBanner =
    !hideBanner && (hasEmergencyMaintenance || hasPlannedMaintenance)

  const isPlannedMaintenanceActive =
    hasPlannedMaintenance &&
    moment(globalSettings.maintenance.end).isAfter(moment())

  const shouldRenderBanner =
    hasEmergencyMaintenance || isPlannedMaintenanceActive

  useEffect(() => {
    API.get('/globalsettings').then((res) => {
      if (res.status === 200) {
        setGlobalSettings(res.data)
      }
    })
  }, [])

  return (
    <AnimatePresence>
      {showBanner && shouldRenderBanner && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.4 }}
        >
          <Box
            sx={{
              backgroundColor: globalSettings?.maintenance?.involvesData
                ? '#ffdadaff'
                : '#fff4e5',
              borderBottom: '1px solid',
              borderColor: globalSettings.maintenance?.involvesData
                ? '#ff4a4aff'
                : '#ffd699',
              boxShadow: theme.shadows[2],
              px: 1,
              py: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              justifyContent: 'center',
              position: 'relative',
              zIndex: 1000,
            }}
          >
            <Stack
              direction={{ xs: 'column', lg: 'row' }}
              alignItems="center"
              justifyContent="center"
            >
              {isUpcoming ? (
                <Typography
                  variant="body2"
                  sx={{
                    color: '#5c3900',
                    fontWeight: 500,
                    textAlign: 'center',
                    textWrap: 'wrap',
                  }}
                >
                  AmbuNet will be undergoing planned maintenance from{' '}
                  {moment(globalSettings?.maintenance?.start).format(
                    'Do MMM HH:mm',
                  )}{' '}
                  until{' '}
                  {moment(globalSettings?.maintenance?.end).format(
                    'Do MMM HH:mm',
                  )}
                  . AmbuNet will be unavailable during this time. This
                  maintenance is essential to ensuring AmbuNet remains fast and
                  secure.
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  sx={{
                    color: '#5c3900',
                    fontWeight: 500,
                    textAlign: 'center',
                    textWrap: 'wrap',
                  }}
                >
                  {`We are currently undertaking ${globalSettings?.maintenance?.emergencyMaintenance ? 'unplanned' : 'planned'} maintenance. ${
                    globalSettings.maintenance?.involvesData
                      ? 'Please DO NOT save any new data during this time.'
                      : 'During this time, some features may be temporarily unavailable.'
                  }`}{' '}
                  If this will affect your operations, please call us 24/7 on{' '}
                  <a href="tel:+443300570620">0300 057 0620.</a>
                </Typography>
              )}
              <IconButton
                onClick={() => setHideBanner(true)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  minWidth: 'unset',
                  padding: 0,
                  color: '#5c3900',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  lineHeight: 1,
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <Close />
              </IconButton>
            </Stack>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default GlobalBanners
